import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';


function MeetingAgenda() {
  return (
    <>
<Features docname="Meeting Agenda and Task Execution"/>
<Advantages docname="Meeting Agenda and Task Execution"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default MeetingAgenda;
